// extracted by mini-css-extract-plugin
export default {"myAgent":"styles_myAgent__4l3Uh","myAgentTitle":"styles_myAgentTitle__OO6+r","myAgentTitleData":"styles_myAgentTitleData__PiqCF"};